import { createSlice } from '@reduxjs/toolkit';
import { CreateInvoiceAsync, UpdateInvoiceAsync, createInvoiceAmountAsync, deleteInvoiceAmountAsync, deleteInvoiceByIdAsync, generateCostEstimatePdfAsAttachmentAsync, generateCostEstimatePdfAsync, generateInvoicePdfAsAttachmentAsync, generateInvoicePdfAsync, getAllInvoiceAmountsAsync, getAllInvoiceAsync, getAllInvoiceStatusAsync, getIncrementedInvoiceNumberAsync, getInvoiceAmountByIdAsync, getInvoiceByIdAsync, getWorkOrdersListWithClientAsync, updateBulkInvoiceAmountAsync, updateInvoiceAmountAsync, updateInvoiceAmountPositionAsync } from './invoiceThunk';
import { APIStatus } from '@application/common/enums/api-status';
import { AppConsts } from '@application/common/constants/app-consts';
const invoiceRequest = {
    pageNumber: AppConsts.GRID_DEFAULT_PAGE_NUMBER,
    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE
};
const initialState = {
    status: APIStatus.IDLE,
    invoiceRequest: invoiceRequest
};
export const invoiceSlice = createSlice({
    name: 'invoice',
    initialState,
    reducers: {
        clearSingleInvoiceAmount: (state) => {
            state.InvoiceAmount = null;
        },
        setInvoiceWorkOrderNumber: (state, action) => {
            state.WorkOrderNumber = action.payload;
        },
        setInvoiceNotes: (state, action) => {
            state.InvoiceNote = action.payload;
        },
        clearInvoiceWorkOrderNumber: (state) => {
            state.WorkOrderNumber = null;
        },
        clearInvoiceNotes: (state) => {
            state.InvoiceNote = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllInvoiceAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllInvoiceAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.invoices = action.payload;
        })
            .addCase(getAllInvoiceAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllInvoiceStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllInvoiceStatusAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.invoiceStatus = action.payload;
            state.invoiceStatusDropdown = action.payload.map((status) => {
                return {
                    label: `${status.name}`,
                    value: status.id
                };
            });
        })
            .addCase(getAllInvoiceStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getInvoiceByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getInvoiceByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updateInvoice = action.payload;
            state.unchangedInvoice = action.payload;
        })
            .addCase(getInvoiceByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getWorkOrdersListWithClientAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getWorkOrdersListWithClientAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.workOrderListWithClient = action.payload;
            state.workOrderListWithClientOptions = action.payload.map((workOrder) => {
                return {
                    label: workOrder.workOrderNumber,
                    value: workOrder.id
                };
            });
        })
            .addCase(getWorkOrdersListWithClientAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getIncrementedInvoiceNumberAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getIncrementedInvoiceNumberAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.invoiceNumber = action.payload;
        })
            .addCase(getIncrementedInvoiceNumberAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(CreateInvoiceAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(CreateInvoiceAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.createdInvoice = action.payload;
            state.unchangedInvoice = action.payload;
        })
            .addCase(CreateInvoiceAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(UpdateInvoiceAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(UpdateInvoiceAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updatedInvoice = action.payload;
        })
            .addCase(UpdateInvoiceAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createInvoiceAmountAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createInvoiceAmountAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.CreatedInvoiceAmount = action.payload;
        })
            .addCase(createInvoiceAmountAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllInvoiceAmountsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllInvoiceAmountsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.InvoiceAmounts = action.payload;
        })
            .addCase(getAllInvoiceAmountsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateInvoiceAmountAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateInvoiceAmountAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.UpdatedInvoiceAmount = action.payload;
        })
            .addCase(updateInvoiceAmountAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getInvoiceAmountByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getInvoiceAmountByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.InvoiceAmount = action.payload;
        })
            .addCase(getInvoiceAmountByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteInvoiceAmountAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteInvoiceAmountAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deleteInvoiceAmountAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteInvoiceByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteInvoiceByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deleteInvoiceByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateInvoiceAmountPositionAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateInvoiceAmountPositionAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(updateInvoiceAmountPositionAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateBulkInvoiceAmountAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateBulkInvoiceAmountAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            //state.QuotationAmounts = action.payload;
        })
            .addCase(updateBulkInvoiceAmountAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generateCostEstimatePdfAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generateCostEstimatePdfAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generateCostEstimatePdfAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generateInvoicePdfAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generateInvoicePdfAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generateInvoicePdfAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generateCostEstimatePdfAsAttachmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generateCostEstimatePdfAsAttachmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generateCostEstimatePdfAsAttachmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generateInvoicePdfAsAttachmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generateInvoicePdfAsAttachmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generateInvoicePdfAsAttachmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default invoiceSlice.reducer;
export const { clearSingleInvoiceAmount, setInvoiceWorkOrderNumber, setInvoiceNotes, clearInvoiceWorkOrderNumber, clearInvoiceNotes } = invoiceSlice.actions;
